

import React from "react";
import ItemCard from "../../../components/itemCard";
import ProductCard from "../../../components/ProductCards";
import { Link } from "react-router-dom";

export default function CategorySection({
  get_Field_Application = [],
  products = [],
}) {
  const orderedMapped = [
    {
      name: "Cardiovascular Ultrasound",
      subtext: "The Next Dimension in Echocardiography",
      description:
        "Powered by AI-based capabilities, our industry-leading CV ultrasound platform delivers advanced tools for structural heart disease, including 3D automated tricuspid valve and color flow quantification tools. Efficient automation and quantification tools enable you to diagnose heart failure and coronary artery disease quickly and confidently. Tiny transducers, high frame rates and sharp imaging support confidence in pediatric echo exams. Seamless on- and off-cart workflow supports lab setup and consistent UI and workflow across systems.",
      value: "Cardiovascular",
      image: require("../../../assets/Products/Cardiovascular.png"),
    },
    {
      name: "General Imaging Ultrasound",
      subtext: "One Platform, One User Experience",
      description: "Designed to empower clinical decisions, enhance patient experiences and support efficiency, our portfolio of smart, connected General Imaging ultrasound systems deliver people-centric workflows, a shared platform and interface across our systems to streamline training and staffing flexibility, and image quality that sets us apart.",
      value: "General Imaging",
      image: require("../../../assets/Products/GeneralImaging.png"),
    },
    {
      name: "Obstetrics and Gynecology",
      subtext: "Confident Obstetrics and Gynecology Ultrasound Imaging",
      description:
        "Our obstetrics and gynecology (OB/GYN) ultrasound solutions provide exceptional imaging for confident decision-making, end-to-end workflow efficiency for both clinicians and patients, and expanded imaging access and collaboration when and where needed – all with a trusted partner that you can rely on.",
      value: "Obstetrics and Gynecology",
      image: require("../../../assets/Products/ObstetricsAndGynecology.png"),
    },
    {
      name: "Point of Care",
      subtext: "Providing High-Quality Portable Imaging, Everywhere You Need to Be",
      description:
        "From handheld devices to premium cart-based systems, our point-of-care portfolio is ergonomic, intuitive and can support a confident diagnosis with a variety of options for any work environment. Our exceptional clinical education support, security and service enhance ease-of-use and deliver lifetime value period.",
      value: "Point of Care",
      image: require("../../../assets/Products/PointOfCare.png"),
    },
  ];

  return (
    <>
      {orderedMapped.map((category, index) => {
        const matchedCategory = Array.from(get_Field_Application).find(
          (item) => item === category.value || item === category.name
        );

        return (
          <div className={`w-[100%] ${index % 2 ? "bg-white" : ""}`} key={index} id={category.value}>
            <div className={`my-5 py-10 md:px-32`}>
              <div className="md:mx-auto w-[100%]">
                <ItemCard
                  title={<><h3>{category?.name || matchedCategory}</h3>
                    <h6 className="font-bold text-xl">{category?.subtext}</h6>
                  </>}
                  // subtext={matchedCategory?.subtext}
                  description={category?.description}
                  direction="right"
                  imageSrc={
                    category?.image
                      ? category.image
                      : require("../../../assets/Products/GeneralImaging.png")
                  }
                />
                <br />
                <div className="flex items-start justify-evenly w-full flex-wrap">
                  {(() => {
                
                    const matchedProducts = products.filter((p) =>
                      p.clinicalSegments.fieldOfApplication.some(
                        (field) => field === matchedCategory
                      )
                    );

                    const displayedProducts =
                      matchedProducts.length > 0
                        ? matchedProducts.slice(0, 3)
                        : [] 

                    return displayedProducts.map((p) => (
                      <ProductCard
                        key={p._id}
                        imageSrc={p.images[0]?.url ? p.images[0].url : p.images[0]}
                        title={p.name}
                        subtitle={p.subName}
                        features={p.feature}
                        description={{
                          title: "Clinical Segments Served",
                          data:
                            "Abdomen and Liver, Critical Care, Emergency Medicine, Musculoskeletal, Pediatrics, ......",
                        }}
                        id={p._id}
                      />
                    ));
                  })()}

                </div>
                <div className="flex items-end justify-end p-5">
                  <Link
                    to={`/product/${matchedCategory}`}
                    state={products}
                    className="text-[#005CB9] text-center font-bold text-lg md:text-xl hover:text-blue-500"
                  >
                    <br />
                    <p>
                      <span className="mx-2 font-bold hover:mx-1">See All</span>
                      <i className="fa-solid font-bold  fa-arrow-right"></i>
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
